<template>
    <div id="app" >
        <router-view />
        <new-footer />
    </div>
  </template>

<script>
  import { NewFooter } from '@/components'
  export default {
    name: 'NewLayout',
    data () {
      return {}
    },
    components: {
      NewFooter
    },
    computed: {},
    created () {},
  }
</script>

<style lang="scss">
  @import "@/assets/styles/home.scss";
  @import "@/assets/mobile/home.scss";
</style>
